import { TableRow, TableCell, IconButton, Menu, MenuItem, useTheme, Box, Paper, SxProps, Table, TableBody, TableContainer, TableHead, Typography } from "@mui/material"
import {
    AccountCircleOutlined as AccountCircleOutlinedIcon,
    MoreVertOutlined as MoreVertOutlinedIcon
} from "@mui/icons-material"
import { useState } from "react"
import { MemberRelative } from "../../../clients"

interface MyAccountMembershipRelativesProps {
    sx?: SxProps
    relatives: MemberRelative[]
}

export const MyAccountMembershipRelatives = ({ sx, relatives }: MyAccountMembershipRelativesProps) => {

    const theme = useTheme()

    const renderRelativeRow = (relative: MemberRelative) => {
        return (
            <RelativesRow
                key={relative.id}
                relative={relative}
            />
        )
    }

    return (
        <Paper sx={{ ...sx, border: '1px solid', borderColor: theme.palette.secondary.main, borderRadius: '3px', p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography>Relatives</Typography>
            </Box>
            <TableContainer sx={sx} component={Box}>
                <Table sx={{ minWidth: 500 }} aria-label='Phones'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Relationship</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {relatives.map(renderRelativeRow)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )


}

interface RelativesRowProps {
    relative: MemberRelative
}

const RelativesRow = ({ relative }: RelativesRowProps) => {

    const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null)

    const handleCloseMenu = () => {
        setMenuAnchorEl(null)
    }

    return (
        <TableRow>
            <TableCell>
                {relative.familyName}, {relative.givenName}
            </TableCell>
            <TableCell>{relative.relationshipToMember}</TableCell>
            <TableCell sx={{ textAlign: 'end' }}>
                <IconButton onClick={e => setMenuAnchorEl(e.currentTarget)}>
                    <MoreVertOutlinedIcon />
                </IconButton>
                <Menu
                    id="menu-member-relative-options"
                    anchorEl={menuAnchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleCloseMenu}
                    keepMounted
                >
                    {
                        relative.accountId &&
                        <MenuItem>
                            <AccountCircleOutlinedIcon sx={{ mr: 1 }} /> View Account
                        </MenuItem>
                    }
                </Menu>
            </TableCell>
        </TableRow>
    )
}